export default __webpack_public_path__ + "static/media/drink4.54a58d75.jpg";